<template>
    <v-card>
        <s-crud
        :config="config"
        :filter="filter"
        add
        :edit="item?.length > 0"
        @edit="editWorker($event)"
        addNoFunction
        @add="addWorker($event)"
        remove
        title="Marcaciones"
        searchInput
        @rowSelected="selectedWorker($event)"
        btnsearch
        >
        <template v-slot:filter>
            <v-container>
                <v-row>
                    <v-col cols="12" md="4">
                        <s-select-campaign-se 
                            label="Campaña"
                            v-model="filter.CmpID"
                            clearable
                        />
                        <s-select-definition
                            label="Tipo de Planilla"
                            :def="1060"
                            v-model="filter.TypePayroll"
                            clearable
                        ></s-select-definition>
                        <s-select-area
                            label="Area"
                            v-model="filter.AreID"
                            clearable
                        ></s-select-area>
                        <s-select
                            label="Cuadrilla"
                            :items="quadrille"
                            autocomplete
                            item-text="GngName"
                            item-value="GngID"
                            v-model="filter.GngID"
                            clearable
                        ></s-select>
                    </v-col>
                    <v-col cols="12" md="4" style="display:flex; flex-direction: column; justify-content: space-between !important;">
                        <s-select-definition
                            label="Turno"
                            :def="1278"
                            v-model="filter.TypeTurn"
                            clearable
                        ></s-select-definition>
                        <s-switch label="Por Fecha" v-model="filter.SelectDate" :true-value="true" :false-value="false" />
                        <s-date label="Fecha desde" :disabled="disabledDate" v-model="filter.MrkDateEntry" clearable></s-date>
                        <s-date label="Fecha hasta" :disabled="disabledDate" v-model="filter.MrkDateExit" clearable></s-date>
                    </v-col>
                    <v-col>
                        <s-toolbar-person noCamera label="Trabajador" noEdit v-model="filter.PrsDocumentNumber" @returnPerson="returnPerson($event, item)" />
                    </v-col>
                </v-row>
            </v-container>
        </template>
        </s-crud>

        <v-dialog v-model="dialogAdd" max-width="400px" persistent>
            <v-card>
                <s-toolbar label="Marcaciones de Trabajador" dark save color="#8e8f91" close @close="dialogAdd = false"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <s-toolbar-person noCamera label="Trabajador" noEdit v-model="itemAdd.PrsDocumentNumber" @returnPerson="returnPerson($event, item)" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <s-date label="Fecha" v-model="itemAdd.MrkDate" clearable></s-date>
                        </v-col>
                        <v-col cols="12" md="6">
                            <s-text type="time" label="Hora" v-model="itemAdd.MrkTime"></s-text>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <s-select-definition
                                label="Incidencia Marcado"
                                :def="1527"
                                v-model="itemAdd.MrkStatusMarking"
                                clearable
                            ></s-select-definition>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <s-textarea label="Observaciones" v-model="itemAdd.MrkObservations"></s-textarea>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import _sQuadriService from "@/services/HumanResource/hmnGang.js";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";

import _sMarking from "@/services/HumanResource/HmnMarkingService";

export default {
    components: { sToolbarPerson },
    data() {
        return {
            itemAdd: {},
            dialogAdd: false,
            disabledDate: false,
            quadrille: [],
            item: {},
            data: {

            },
            filter: {
                CmpID: null,
                TypePayroll: null,
                AreID: null,
                GngID: null,
                TypeTurn: null,
                SelectDate: true,
                MrkDateEntry: this.$fun.getDate(),
                MrkDateExit: this.$fun.getDate()
            },
            config: {
                service: _sMarking,
                model: {
                    MrkID: "ID",
                    MrkDateMarking: "date",
                    MrkMarkingCalculation: "time2",
                },
                headers: [
                    // { text: "MrkID", value: "MrkID" },
                    { text: "WkrID", value: "WkrID" },
                    { text: "Documento", value: "PrsDocumentNumber" },
                    { text: "Apellidos y Nombres", value: "NtpFullName" },
                    { text: "Area", value: "AreName" },
                    { text: "Dia", value: "MrkRangeName" },
                    { text: "Fecha", value: "MrkDateMarking" },
                    { text: "Rango", value: "MrkRange" },
                    { text: "Hora", value: "MrkMarkingCalculation" },
                    { text: "Marcado", value: "StatusMarkingName" },
                    { text: "Estado", value: "MrkStatusMarking" },
                    { text: "Temprano", value: "MrkEarly" },
                    { text: "Tardanza", value: "MrkTardiness" },
                    { text: "Tipo", value: "MrkType" },
                    { text: "Equipo", value: "BieEquipmentName" },
                    { text: "Observación", value: "MrkObservation" },
                    { text: "Laboral", value: "" },
                ]
            },
        };
    },
    methods: {
        getQuadrille() {
            let obj = {
                SecStatus: 1,
            };
            _sQuadriService.list(obj, this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                this.quadrille = resp.data;
                }
            });
        },
        returnPerson(value, item) {
            this.data.NtpFullName = value.NtpFullName;
            this.data.PrsDocumentNumber = value.PrsDocumentNumber;
            this.data.NtpID = value.NtpID;
            this.data.PrsID = value.PrsID;
            this.data.WkrID = value.WkrID;
        },
        addWorker() {
            this.dialogAdd = true;
            this.itemAdd = {};
        },
        editWorker(item) {
            this.dialogAdd = true;
            this.itemAdd = {...item};
        },
        selectedWorker(item) {
            console.log(item);
            if (item.length == 0) {
                this.item = item[0];
            }
        },
    },
    created() {
        this.getQuadrille();
    },
    watch: {
        "filter.SelectDate"(value) {
            if (!value){
                this.filter.MrkDateEntry = null;
                this.filter.MrkDateExit = null;
                this.disabledDate = true;
            }else{
                this.disabledDate = false;
                this.filter.MrkDateEntry = this.$fun.getDate();
                this.filter.MrkDateExit = this.$fun.getDate();
            }
        },
    },
};
</script>